/* 单据查询 - 报销单表单状态 */
const BILL_SEARCH_REIMBURSEMENT_STATUS = {
  1: '审批中',
  2: '已同意',
  3: '已驳回',
  4: '待审批',
  5: '已作废'
}

/* 单据类型 */
const BILL_TYPE = {
  1: '经费结算单 ',
  2: '预审批单',
  3: '差旅报销单 ',
  4: '未使用公务卡结算审批单',
  5: '出差预审批单'
}

/* 伙食模块 - 供应商管理 - 供应商类型 */
const FOOD_SUPPLIER_TYPE = {
  1: '定点配送',
  2: '定点采购',
}

/* 固定资产模块 - 资产列表 - 资产状态 */
const FIXED_ASSETS_STATUS = {
  1: '报废',
  2: '正常',
  3: '遗失',
  4: '损坏',
}

/* 固定资产模块 - 审批记录列表 - 审批状态 */
const FIXED_ASSETS_RECORD_STATUS = {
  3: '资产申领 ',
  4: '资产报废',
  5: '资产移交',
  6: '资产盘盈',
  7: '资产盘亏',
  8: '资产调拨',
}

/* 固定资产模块 - 审批记录列表 - 接受状态 */
const FIXED_ASSETS_RECORD_RECEVICE_STATUS = {
  1: '未接收  ',
  2: '已接收',
  3: '已拒收'
}

/* 固定资产模块 - 审批记录列表 - 审批记录状态 */
const FIXED_ASSETS_RECORD_PROCEDURE_STATUS = {
  1: '已同意',
  2: '已驳回',
  3: '待定',
}

/* 风险模块 - 预警发布列表 - 发布状态 */
const RISK_RELEASE_STATUS = {
  'TO_BE_CHECKED': '待检查',
  'TO_BE_CONFIRMED': '待确认',
  'TO_BE_RECTIFIED':'待整改',
  'TO_BE_CLEARED':'待清除',
  'COMPLETED':'已完成',
  'REVOKED': '已撤销'
}

/* 风险模块 - 风险等级 */
const RISK_LEVEL = {
  'HIGH': '高风险',
  'MIDDLE': '中风险',
  'LOW': '低风险'
}

/* 风险模块 - 风险审核状态 */
const RISK_APPROVAL_STATUS = {
  'TO_BE_CHECKED': '待检查',
  'TO_BE_CONFIRMED': '待确认',
  'TO_BE_RECTIFIED': '待整改',
  'TO_BE_CLEARED': '待清除',
  'COMPLETED': '已完成',
  'REVOKED': '已撤销',
}

const UNIT = {
  1: '斤',
  2: '个(袋/包/瓶)',
  3: '箱(板)',
  4: '公斤',
}

const REIMBURSEMENT_ROLE_TYPE = {
  1: '部门负责人',
  2: '业务分管领导',
  3: '财务审核人',
  4: '财务负责人',
  5: '财务分管领导',
  6: '单位主官',
  7: '出纳',
  8: '采购人',
  9: '验收人',
  10: '资产管理员',
  11: '工薪制表人',
  12: '部门负责人'
}

/* 报销单---流程状态 */
const REIMBURSEMENT_PROCEDURE_STATUS = {
  1: '已同意',
  2: '已驳回',
  3: '待审批'
}

export const statusMixins = {
  data() {
    return {
      BILL_SEARCH_REIMBURSEMENT_STATUS,
      FOOD_SUPPLIER_TYPE,
      FIXED_ASSETS_STATUS,
      FIXED_ASSETS_RECORD_STATUS,
      FIXED_ASSETS_RECORD_RECEVICE_STATUS,
      FIXED_ASSETS_RECORD_PROCEDURE_STATUS,
      RISK_RELEASE_STATUS,
      RISK_LEVEL,
      RISK_APPROVAL_STATUS,
      BILL_TYPE,
      UNIT,
      REIMBURSEMENT_ROLE_TYPE,
      REIMBURSEMENT_PROCEDURE_STATUS
    }
  }
}